import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

import { useStyles } from "../UserDashboard.css";
import BookIcon from "../../../../Assets/Logo/BookIcon.svg";
import NoticeIcon from "../../../../Assets/Logo/NoticeIcon.svg";
import FeeIcon from "../../../../Assets/Logo/FeeIcon.svg";
import UserDashboardCard from "../UserDashboardCard/UserDashboardCard";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { engMonths } from "../../../../Components/Data/Months";
import StudentAttendanceCard from "./StudentAttendanceCard/StudentAttendanceCard";
import StudentLibraryCard from "./StudentLibraryCard/StudentLibraryCard";
import { getUserRefreshToken } from "../../../../Redux/Actions/actions";

class StudentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          label: "Total Books in Library",
          count: 0,
          url: "/library",
          icon: (
            <img src={BookIcon} alt="Books" style={{ width: 50, height: 50 }} />
          ),
        },
        {
          label: "Total Notice this month",
          count: 0,
          url: "/notices",
          icon: (
            <img
              src={NoticeIcon}
              alt="Notices"
              style={{ width: 50, height: 50 }}
            />
          ),
        },
        {
          label: "Bills this session",
          count: 0,
          url: "/fees",
          icon: (
            <img src={FeeIcon} alt="Fees" style={{ width: 50, height: 50 }} />
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.studentDashboard();
  }

  studentDashboard = async () => {
    try {
      const bookResponse = await Axios.get(`${url}/api/books`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      this.setCount("Total Books in Library", bookResponse.data.books.length);

      const noticeResponse = await Axios.get(`${url}/api/notices`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      let filterNotice = noticeResponse.data.notices.filter((data) => {
        return (
          moment(data.createdAt).format("YYYY") ===
            moment(new Date()).format("YYYY") &&
          moment(data.createdAt).format("MM") ===
            moment(new Date()).format("MM")
        );
      });
      this.setCount("Total Notice this month", filterNotice.length);

      const feeResponse = await Axios.get(
        `${url}/api/student-fees/${this.props.userId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        }
      );
      let sessionFilter = feeResponse.data.studentFees.filter(
        (data) => data.session === new Date().getFullYear().toString()
      );
      let filteredFees = [];
      for (let i = 0; i <= engMonths.length - 1; i++) {
        let tempData = sessionFilter.map((data) =>
          data.fees.filter((filterData) => filterData.month === engMonths[i])
        );
        filteredFees.push(tempData);
      }
      let count = 0;
      for (let i = 0; i <= filteredFees.length - 1; i++) {
        if (filteredFees[i][0].length > 0) {
          count++;
        }
      }
      this.setCount("Bills this session", count);
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getStudentDashboard();
      }
    }
  };

  setCount = (label, tempCount) => {
    let newArray;
    newArray = this.state.data.map((data) =>
      data.label === label
        ? { ...data, count: tempCount }
        : { ...data, count: data.count }
    );
    this.setState({
      data: newArray,
    });
  };

  render() {
    return (
      <div>
        <Grid container spacing={3}>
          {this.state.data.map((data, index) => (
            <UserDashboardCard
              key={index}
              url={data.url}
              label={data.label}
              count={data.count}
              icon={data.icon}
            />
          ))}
        </Grid>
        <Grid container spacing={3}>
          <StudentAttendanceCard />
          <StudentLibraryCard />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(StudentDashboard));
